import { render, staticRenderFns } from "./ColorSwatches.vue?vue&type=template&id=d9fe2ebc"
import script from "./ColorSwatches.vue?vue&type=script&lang=js"
export * from "./ColorSwatches.vue?vue&type=script&lang=js"
import style0 from "./ColorSwatches.vue?vue&type=style&index=0&id=d9fe2ebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports